import GridCard from '@Guidelines/Component/GridCard';
import LimitRowActions from '@UI/Pages/Administration/AiCostLimits/Sections/LevelLimits/LimitRow/LimitRowActions';
import LimitDetails from '@UI/Pages/Administration/AiCostLimits/Shared/LimitDetails';
import type AiCostLimitView from '@UI/Store/AiCostLimits/Views/AiCostLimitView';
import type * as React from 'react';

type Props = {
	readonly limit: AiCostLimitView;
	readonly subjectName: string;
};

const LimitRow: React.FC<Props> = ({ limit, subjectName }) => {
	return (
		<GridCard layout="stacked" rowGap="0.75rem" tone={limit.isBlocking ? 'warning' : 'default'}>
			<LimitDetails limit={limit} subjectName={subjectName} />
			<LimitRowActions limitId={limit.id} subjectName={subjectName} />
		</GridCard>
	);
};

export default LimitRow;
